var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 43.189,
    viewBox: "0 0 56 43.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 56,
    height: 43.189,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC81C\\uC678_5",
    "data-name": "\\uC81C\\uC678 5",
    d: "M432-18.811H374.715a21.457,21.457,0,0,0,8.383-1.7,21.521,21.521,0,0,0,6.864-4.628A21.522,21.522,0,0,0,394.59-32a21.459,21.459,0,0,0,1.7-8.405,21.462,21.462,0,0,0-1.7-8.406,21.522,21.522,0,0,0-4.628-6.864A21.52,21.52,0,0,0,383.1-60.3a21.457,21.457,0,0,0-8.405-1.7H432v43.188Zm-373.84,0H0V-62H58.436a21.457,21.457,0,0,0-8.384,1.7,21.52,21.52,0,0,0-6.864,4.628,21.522,21.522,0,0,0-4.628,6.864,21.462,21.462,0,0,0-1.7,8.406A21.459,21.459,0,0,0,38.561-32a21.522,21.522,0,0,0,4.628,6.864,21.522,21.522,0,0,0,6.864,4.628,21.449,21.449,0,0,0,8.107,1.695Z",
    transform: "translate(-7073 -9432)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186076",
    "data-name": "\\uADF8\\uB8F9 186076",
    transform: "translate(7073 9448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC2A4\\uD06C\\uB864_\\uADF8\\uB8F9_48",
    "data-name": "\\uC2A4\\uD06C\\uB864 \\uADF8\\uB8F9 48",
    transform: "translate(-7074 -9448)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186075",
    "data-name": "\\uADF8\\uB8F9 186075",
    transform: "translate(7074 9510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_33",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 33",
    transform: "translate(-1 -16)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154647",
    "data-name": "\\uC0AC\\uAC01\\uD615 154647",
    width: 58,
    height: 43,
    transform: "translate(-7073 -9494)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryWhite);
export default __webpack_public_path__ + "static/media/history_white.1b4228af4f9cc149621394d9142080ad.svg";
export { ForwardRef as ReactComponent };